"use client";

import dynamic from "next/dynamic";

const PixelBlast = dynamic(() => import("./PixelBlast"), { ssr: false });

export default function HeroBackground() {
    return (
        <div className="absolute inset-0 z-0 hidden md:block">
            <PixelBlast
                color="#1a1a1a"
                pixelSize={6}
                variant="diamond"
                patternScale={5}
                patternDensity={0.5}
                speed={0.7}
                edgeFade={0.32}
                rippleIntensityScale={0.5}
            />
        </div>
    );
}
